import { useEffect } from 'react';

import { useLayout } from '~hooks';
import { useOnboarding } from '~contexts/OnboardingContext';

import * as Styled from './styled';
import { RepresentativeCard, OrderStatus } from './sections';
import * as amplitude from '@amplitude/analytics-browser';

const statusBannerMap = {
  'documents-validation': 'pending',
  approved: 'pending',
  reproved: 'denied',
  'account-denied': 'denied',
};

function RepresentantSendingDocuments() {
  const { setLayout } = useLayout();
  const onboarding = useOnboarding();

  useEffect(() => {
    setLayout({
      header: {
        title: 'Acompanhamento do envio de documentos e selfie',
        subtitle:
          'Agora precisamos dos dados pessoais dos representantes legais:',
        position: 'right',
      },
    });

    amplitude.track({
      event_type: 'documentation_check_list_loaded',
      event_properties: {
        legal_representatives_details: onboarding.representatives,
      },
    });
  }, []);

  return (
    <Styled.Container>
      {onboarding && (
        <>
          {[
            'documents-validation',
            'reproved',
            'approved',
            'account-denied',
          ].includes(onboarding.status) && (
            <OrderStatus status={statusBannerMap[onboarding.status]} />
          )}

          {onboarding.representatives.map((representative) => (
            <RepresentativeCard
              key={representative.id}
              onboardingStatus={onboarding.status}
              representative={representative}
            />
          ))}
        </>
      )}
    </Styled.Container>
  );
}

export default RepresentantSendingDocuments;
